/*!
 * Copyright © 2019-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EDrivingLimitWarning {
  None = 0,
  In15Min = 1,
  Reached = 2
}
